import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Shipping from "./Shipping/Shipping";
import Payment from "./Payment/Payment";
import { CartData } from "../../interfaces/CartData";
import { ShippingOption } from "../../interfaces/ShippingOption";
import * as intrfce from "./Interfaces";

interface CheckoutStep2Props {
  cartData: CartData | undefined;
  shippingList: ShippingOption[];
    shippingOptions: intrfce.iShippingDetails;
  validationErrors: Record<string, string>;
  handleShippingMethodChange: (field: string, value: any) => void;
  selectedBillingAddress: intrfce.iSavedAddress | null | "reset";
  savePayment: boolean;
  formBillingAddress: intrfce.iAddressFormData;
  formBillingData: intrfce.iBillingFormData;
  handleFormSubmit: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  enableReviewOrderBtn: boolean;
  handleBackToAddresses: () => void;
}

const CheckoutStep2: React.FC<CheckoutStep2Props> = ({
  cartData,
  shippingList,
  shippingOptions,
  validationErrors,
  handleShippingMethodChange,
  selectedBillingAddress,
  savePayment,
  formBillingAddress,
  formBillingData,
  handleFormSubmit,
  enableReviewOrderBtn,
  handleBackToAddresses,
}) => {
  const { t } = useTranslation();

  return (
      <>      
      {/* Payment Information */}
      <Row xs={"auto"} md={"auto"}>
        <Col md={12}>
          {cartData && (
            <Payment
              billingData={selectedBillingAddress}
              savePayment={savePayment}
              validationErrors={validationErrors}
              formBillingAddress={formBillingAddress}
              formBillingData={formBillingData}
            />
          )}
        </Col>
      </Row>
    {/* Shipping Method Selection */}
    {cartData && (
        <Shipping
            shippingList={{ shippingOption: shippingList }}
            defaultShippingMethodCode={shippingOptions.shippingOption}
            validationErrors={validationErrors}
            onInputChange={handleShippingMethodChange}
        />
    )}

      {/* Navigation Buttons */}
      <Row xs={"auto"} md={"auto"} className="mt-4">
        <Col md={12} className="d-flex justify-content-between align-items-center">
          <Button
            variant="outline-secondary"
            size="lg"
            onClick={handleBackToAddresses}
                      className="back-button btn-green"
          >
                      {t("BTN_BACK")}
          </Button>
          <Button
            type="button"
            variant="success"
            size="lg"
                      className="btn-green continue-button"
            onClick={handleFormSubmit}
            disabled={!enableReviewOrderBtn}
            aria-label={t("BTN_REVIEW_ORDER")}
          >
            {t("BTN_REVIEW_ORDER")}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default CheckoutStep2;

